export enum DeviceGeneration {
  Gen1 = 1,
  Gen2 = 2,
}
